import { IsoDateTime } from '../../types/iso-date';

export function isIsoDateTime(str: string): str is IsoDateTime {
  // Strict format: YYYY-MM-DDTHH:mm:ss(.fraction)? with no timezone
  // - Hours: 00-23, Minutes: 00-59, Seconds: 00-59
  // - Fractional seconds: 1-6 digits allowed
  const re = /^(\d{4})-(\d{2})-(\d{2})T([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?$/;
  const m = re.exec(str);
  if (!m) return false;

  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const hour = Number(m[4]);
  const minute = Number(m[5]);
  const second = Number(m[6]);
  const fraction = m[7]; // optional fractional seconds (up to microseconds)

  // Validate the calendar date using Date; JS Date months are 0-based
  // Convert fraction to milliseconds for Date construction; ignore precision beyond ms
  const ms = fraction ? Number((fraction + '000').slice(0, 3)) : 0;
  const d = new Date(year, month - 1, day, hour, minute, second, ms);

  // Ensure all parts match exactly (guards against overflows like 2025-02-30 -> Mar 2)
  return (
    d.getFullYear() === year &&
    d.getMonth() === month - 1 &&
    d.getDate() === day &&
    d.getHours() === hour &&
    d.getMinutes() === minute &&
    d.getSeconds() === second
  );
}
